import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-candidate-reference-accepted',
  templateUrl: './activity-item-candidate-reference-accepted.component.html',
  styleUrls: ['./activity-item-candidate-reference-accepted.component.scss']
})
export class ActivityItemCandidateReferenceAcceptedComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  
  @Input()
  language: 'de' | 'en' = 'de';

  @Input()
  context: string = null;

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
